import groupBy from 'lodash-es/groupBy';
import mapValues from 'lodash-es/mapValues';
import sortBy from 'lodash-es/sortBy';

import { FamilyGroup, ProductWithAttributes } from '@gn-audio/jss-core';

import { AvailabilityState, StandardPriceModel } from '../types/pricesModel';
import { isNotNil } from './isNotNil';

export const sortGroupsByAvailability = (
  groups: FamilyGroup[],
  prices: StandardPriceModel[]
): FamilyGroup[] => {
  return sortBy(
    groups,
    [
      (gr) => {
        const price = prices.find((p) => p.sku === gr.sku);
        if (!price) return AvailabilityState.ComingSoon;
        return price?.availabilityState;
      },
    ],
    ['asc']
  );
};

export const Meta3dEngravingRenderingUuidAttribute = 'Meta_3dEngravingRenderingUuid';
export const ProductPortfolioAttribute = 'Product_Portfolio';
export const MetaProducttypeAttribute = 'Meta_Producttype';
export const ProductEngravingAttribute = 'Product_Engraving';

export const getAvailabilityState = (price?: StandardPriceModel): AvailabilityState => {
  if (!price) {
    return AvailabilityState.WhereToBuy;
  }

  const { availabilityState } = price;
  if (typeof availabilityState === 'number') {
    return availabilityState;
  }

  return AvailabilityState.WhereToBuy;
};

export const getGroupAttributesObject = (
  group?: FamilyGroup | ProductWithAttributes
): Record<string, string[]> => {
  if (!group) return {};
  const attributesDictionary = groupBy(group?.attributes, (attr) => attr.key);
  return mapValues(attributesDictionary, (attributes) =>
    attributes.map((attr) => attr.valueKey).filter(isNotNil)
  );
};

export const getAttributeValue = (
  group: FamilyGroup | ProductWithAttributes | undefined,
  attributeName: string
): string | undefined => {
  if (!group) return;
  return group.attributes?.find((attr) => attr.key === attributeName)?.value ?? undefined;
};
